const getCookie = (name) => {
    if (typeof document !== `undefined`){
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        let result;

        if (parts.length >= 2) {
            if(name === "tracking_profile_id") {
                result = parts.pop().split(';').shift();
                if(result.charAt(0) === ',') {
                    result  = result.substring(1);
                }
                return result
            }
            return parts.pop().split(';').shift()
        } else {
            return false
        }
    }
  }

export default getCookie;